import {ActivityLogView} from "../../../integrated-client";

interface IDayData {
  date?: string
  items: Array<ActivityLogView>
}

export interface IResultsData
{
  results: Array<IDayData>
}

export class ResultsData implements IResultsData{

  results: Array<IDayData>

  constructor() {
    this.results = [];
  }

}
